import { styled } from 'styled-components';

import { spacing3 } from 'src/styles/spacing';

export const StyledBulletList = styled.ul`
  padding-inline-start: ${spacing3};
`;
